/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Iki_FaktorluInputs */

const tr_faq_a_iki_faktorlu = /** @type {(inputs: Faq_A_Iki_FaktorluInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet, Google Authenticator veya benzeri bir uygulama ile TOTP tabanlı iki adımlı doğrulamayı aktif edebilirsin. Ayarlar bölümündeki Güvenlik sayfasından kurulumu birkaç dakikada tamamlayabilirsin. Hesap güvenliğini artırmak için bunu etkinleştirmeni tavsiye ediyoruz.`)
};

const en_faq_a_iki_faktorlu = /** @type {(inputs: Faq_A_Iki_FaktorluInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. You can enable TOTP-based 2FA with Google Authenticator or a similar app. Setup takes a few minutes on the Security page under Settings. We recommend enabling it.`)
};

const de_faq_a_iki_faktorlu = /** @type {(inputs: Faq_A_Iki_FaktorluInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Du kannst TOTP-basierte 2FA mit Google Authenticator oder einer ähnlichen App aktivieren. Die Einrichtung dauert wenige Minuten auf der Seite Sicherheit unter Einstellungen.`)
};

const ru_faq_a_iki_faktorlu = /** @type {(inputs: Faq_A_Iki_FaktorluInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да. Можно подключить TOTP-аутентификацию через Google Authenticator или аналогичное приложение. Настройка займёт несколько минут на странице Безопасность в Настройках.`)
};

/**
* | output |
* | --- |
* | "Yes. You can enable TOTP-based 2FA with Google Authenticator or a similar app. Setup takes a few minutes on the Security page under Settings. We recommend en..." |
*
* @param {Faq_A_Iki_FaktorluInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_iki_faktorlu = /** @type {((inputs?: Faq_A_Iki_FaktorluInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Iki_FaktorluInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_iki_faktorlu(inputs)
	if (locale === "de") return de_faq_a_iki_faktorlu(inputs)
	if (locale === "ru") return ru_faq_a_iki_faktorlu(inputs)
	return tr_faq_a_iki_faktorlu(inputs)
});